import { EyeOutlined } from '@ant-design/icons';
import { AppModal } from 'shared/UI/UIKit/Modal';
import { MaxLessonsPerDayForm } from 'entities/max-lessons-per-day/form';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppTitle } from 'shared/UI/UIKit/Title';
import type { MaxLessonsPerDay } from 'shared/api';
import { useMaxLessonsPerDayView } from '../model';
import styles from './styles.module.scss';

interface MaxLessonsPerDayViewProps {
  maxLessonsPerDay: MaxLessonsPerDay;
}

export const MaxLessonsPerDayView = ({ maxLessonsPerDay }: MaxLessonsPerDayViewProps) => {
  const {
    state: { modalVisible, form },
    methods: { showModal, hideModal },
  } = useMaxLessonsPerDayView({ maxLessonsPerDay });

  return (
    <>
      <EyeOutlined className={styles.icon} onClick={showModal} />

      <AppModal
        content={<MaxLessonsPerDayForm form={form} readOnly />}
        visible={modalVisible}
        onCancel={hideModal}
        destroyOnClose
        customHeader={
          <AppFlex className={styles.header}>
            <AppTitle level={1}>Просмотр конфигурации</AppTitle>
          </AppFlex>
        }
        footer={
          <AppFlex direction="row">
            <AppButton type="outline" onClick={hideModal}>
              Закрыть
            </AppButton>
          </AppFlex>
        }
      />
    </>
  );
};
